import {ellipsis, transparentize} from 'polished';
import styled, {css} from 'styled-components';

import {Icon} from 'components/ui-kit/Icon';
import {border, colors, font} from 'theme';

import {InputVariant} from './types';

const PLACEHOLDER_COLOR = '#aaa';

export const Root = styled.div<{updatedDesign?: boolean}>`
    position: relative;
    display: block;

    ${(p) =>
        p.updatedDesign &&
        css`
            border-radius: ${border.radius};
        `}
`;

export const NativeInput = styled.input`
    position: absolute;
    cursor: pointer;
    opacity: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
`;

export const Label = styled.label<{
    variant: InputVariant;
    updatedDesign?: boolean;
}>`
    position: relative;
    cursor: pointer;
    ${ellipsis()};
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    appearance: none;
    padding: 10px 20px;
    height: 44px;
    width: 100%;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    background-color: #fff;
    box-sizing: border-box;
    color: ${colors.textPrimary};
    outline: none;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    border-color: ${(props) => {
        switch (props.variant) {
            case InputVariant.Normal:
                return colors.brandPrimary;
            case InputVariant.Error:
                return colors.danger;
            default:
                return colors.brandPrimary;
        }
    }};

    &:disabled {
        opacity: 0.5;
    }

    &:focus-within {
        ${(props) => {
            switch (props.variant) {
                case InputVariant.Normal:
                    return css`
                        box-shadow: 0 0 0 2px ${transparentize(0.8, colors.brandPrimary)};
                        border-color: ${() => colors.brandPrimary};
                    `;
                case InputVariant.Error:
                    return css`
                        box-shadow: 0 0 0 2px ${transparentize(0.8, colors.danger)};
                        border-color: ${() => colors.danger};
                    `;
            }
        }}
    }

    &::-webkit-input-placeholder {
        color: ${PLACEHOLDER_COLOR};
    }

    &::-moz-placeholder {
        color: ${PLACEHOLDER_COLOR};
    }

    &:-ms-input-placeholder {
        color: ${PLACEHOLDER_COLOR};
    }

    &::-ms-input-placeholder {
        color: ${PLACEHOLDER_COLOR};
    }

    &::placeholder {
        color: ${PLACEHOLDER_COLOR};
    }

    &::-ms-clear {
        display: none;
    }

    ${(p) =>
        p.updatedDesign &&
        css`
            background-color: ${colors.brandPrimary};
            color: ${colors.white};

            font-family: ${font.family.primary};
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
        `}
`;

export const FileName = styled.span<{updatedDesign?: boolean}>`
    line-height: 40px;
    font-weight: 500;
    font-size: 12px;
    color: ${colors.brandPrimary};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;
    max-width: 300px;

    ${(p) =>
        p.updatedDesign &&
        css`
            color: ${colors.white};
            max-width: fit-content;
            display: flex;
            height: fit-content;
            line-height: 16px;
        `}
`;

export const LoadedWrapper = styled.div<{updatedDesign?: boolean}>`
    display: flex;
    align-items: center;
    gap: 10px;

    ${(p) =>
        p.updatedDesign &&
        css`
            box-sizing: border-box;
            padding: 10px 16px;
        `}
`;

export const CloseFileIcon = styled(Icon)`
    cursor: pointer;
`;
